import React from "react";
import { reduxForm, Field } from "redux-form";
import { RenderField } from "components/Fields";
import { required } from "redux/validation";
import PanelWrapper from "./Panel";

const ErrorMessage = ({ errors }) => (
  <div>{errors && <div className="alert alert-danger">{errors}</div>}</div>
);

const LoginForm = ({ handleSubmit, valid, form }) => (
  <form onSubmit={handleSubmit}>
    <fieldset>
      <Field
        name="login"
        label="Логин"
        component={RenderField}
        type="text"
        validate={[required]}
      />
      <Field
        name="password"
        label="Пароль"
        component={RenderField}
        type="password"
        validate={[required]}
      />
      <button
        type="submit"
        className="btn btn-sm btn-primary"
        disabled={!valid}
      >
      <i class="fas fa-key r-5"></i> Войти
      </button>
    </fieldset>
  </form>
);

const Form = props => (
  <PanelWrapper title={"Авторизация"}>
    <ErrorMessage errors={props.errors} />
    <LoginForm {...props} />
  </PanelWrapper>
);

export default reduxForm({ form: "loginForm", enableReinitialize: true })(Form);
